import { apiClient } from "../config";

async function editProgramTags(programIdId: any, data: any) {
  const res = await apiClient.put(`/admin/programs/${programIdId}/tags`, data);
  return res.data;
}

export default editProgramTags;
